module.exports = __webpack_public_path__ + "img/relation.e4e1dea5.svg";